<template>
  <div :class="[
        openMenu
          ? ''
          : 'none']">
    <!-- 背景 -->
    <div
      class="fixed transition-all w-full h-full t-0 z-502 v-background"
      style="backdrop-filter: blur(14px);"
      :class="[
        openMenu
          ? 'opacity-100 pointer-events-auto'
          : 'opacity-0 pointer-events-none',
      ]"
      @click="handleMenu"
    ></div>
    <!-- 顶部 -->
    <div
      class="fixed transition-all duration-300 z-503 t-0"
      style="display: flex;flex-direction: column;align-items: center;width: 81.08%;;max-width: 400px; background: #1a3a0a;  box-sizing: border-box; padding: 10px 20px;"
      :class="[
        openMenu
          ? 'pointer-events-auto translate-x-0'
          : 'pointer-events-none -translate-x-full',
      ]"
    >
      <div style="display: flex;align-items: center;justify-content: space-between;width: 100%;">
        <div
          class="flex items-center justify-center h-30 rounded-5 px-5"
          @click="handleMenu()" style="background: #3d6b1f;"
        >
          <i class="sysicon-new-clean-2 text-color-white text-18"></i>
        </div>
        <img src="../../../assets/images/b3337.png" style="height: 40px;padding: 0 3.3%"/>
       
      </div>
    </div>
    <!-- 主要内容 -->
    <div
      class="fixed h-full transition-all duration-300 overflow-y-auto z-502 t-0 bg-color"
      style="overscroll-behavior: contain; width: 81.08%;max-width: 400px; padding-top: 80px;"
      :class="[
        openMenu
          ? 'pointer-events-auto translate-x-0'
          : 'pointer-events-none -translate-x-full',
      ]"
    >
      
      <!-- 活动按钮 -->
       
      <div class="">
        
       
        <!-- <div style="border-bottom: 1px solid #00615f; margin: 20px 0px;"></div> -->
        <!-- <div class="menu-func-btns">
          <div class="menu-func-item" @click="handleMenu(),nav('/deposit')">
            <div class="menu-func-left">
              <img src="@/assets/images/icon/btn-bg.png" class="menu-func-left-bg" alt=""/>
              <img src="@/assets/images/icon/recharge.png" class="menu-func-icon" alt=""/>
            </div>
            <div class="menu-func-right">
              <span class="menu-func-text">Depósito</span>
            </div>
          </div>
          <div class="menu-func-item" @click="handleMenu(),nav('/Withdraw')">
            <div class="menu-func-left">
              <img src="@/assets/images/icon/btn-bg.png" class="menu-func-left-bg" alt=""/>
              <img src="@/assets/images/icon/withdraw.png" class="menu-func-icon" alt=""/>
            </div>
            <div class="menu-func-right">
              <span class="menu-func-text">Saque</span>
            </div>
          </div>
          <div class="menu-func-item" @click="handleMenu()">
            <div class="menu-func-left">
              <img src="@/assets/images/icon/btn-bg.png" class="menu-func-left-bg" alt=""/>
              <img src="@/assets/images/icon/Agency.png" class="menu-func-icon" alt=""/>
            </div>
            <div class="menu-func-right">
              <span class="menu-func-text">Agente</span>
            </div>
          </div>
          <div class="menu-func-item" @click="handleMenu(),nav('/promotion')">
            <div class="menu-func-left">
              <img src="@/assets/images/icon/btn-bg.png" class="menu-func-left-bg" alt=""/>
              <img src="@/assets/images/icon/promotion.png" class="menu-func-icon" alt=""/>
            </div>
            <div class="menu-func-right">
              <span class="menu-func-text">Bônus</span>
            </div>
          </div>
          <div class="menu-func-item" @click="handleMenu()">
            <div class="menu-func-left">
              <img src="@/assets/images/icon/btn-bg.png" class="menu-func-left-bg" alt=""/>
              <img src="@/assets/images/icon/AssistanceCash.png" class="menu-func-icon" alt=""/>
            </div>
            <div class="menu-func-right">
              <span class="menu-func-text">Afiliado</span>
            </div>
          </div>
          <div class="menu-func-item" @click="handleMenu()">
            <div class="menu-func-left">
              <img src="@/assets/images/icon/btn-bg.png" class="menu-func-left-bg" alt=""/>
              <img src="@/assets/images/icon/Custom.png" class="menu-func-icon" alt=""/>
            </div>
            <div class="menu-func-right">
              <span class="menu-func-text">Ganhar</span>
            </div>
          </div>
        </div> -->
        <!-- <div style="border-bottom: 1px solid #00615f; margin: 20px 0px;"></div> -->
        <div class="sort">
          <div 
            v-for="item in sortList" 
            :key="item.id" 
            class="sort-item"
            @click="handleSortClick(item)"
          >
            <img v-if="item.img" :src="'https://pg028-api.centuries.cc' + item.img" class="sort-icon" alt=""/>
            <span class="sort-label">{{ item.label }}</span>
          </div>
        </div>

      </div>

      <!-- 功能菜单项 -->
      <div class="menu-func-list">
        <div class="func-item" @click="handleMenu(), nav('/transaction', { type: 2 })">
          <div class="func-item-left">
            <img src="@/assets/images/icon/detail.png" class="func-item-icon" />
          </div>
          <div class="func-item-right">
            <span class="func-item-title">Catatan Taruhan</span>
            <span class="func-item-value">{{ formatMoney(userinfo?.money) }}</span>
          </div>
          <i class="sysicon-new-back rotate-180 text-13 func-item-arrow"></i>
        </div>

        <div class="func-item" @click="handleCustomer">
          <div class="func-item-left">
            <img src="@/assets/images/icon/customer.png" class="func-item-icon" />
          </div>
          <div class="func-item-right">
            <span class="func-item-title">Layanan Pelanggan</span>
          </div>
          <i class="sysicon-new-back rotate-180 text-13 func-item-arrow"></i>
        </div>
      </div>

      <!-- Bonus 活动图片区域 -->
      <div class="bonus-section">
        <!-- <div class="bonus-title">
          <span>Bônus</span>
        </div> -->
        <div class="bonus-list">
          <div
            v-for="(img, index) in bonusImages"
            :key="index"
            class="bonus-item"
            @click="handleBonusClick(img)"
          >
            <img :src="img.src" :alt="img.name" class="bonus-img" />
          </div>
        </div>
      </div>

      <!-- 底部按钮区域 -->
       <div style="border-bottom: 1px solid #4C6B23; margin: 20px 10px;"></div>
     
    </div>
    <GameInfoVfm :item="gameItem" @onclose="handleGameInfoClose" />
    <Vfm :show="showPopup" class="z-1200" :class="[showPopup ? '' : 'none']">
      <div style=" box-shadow: 0 8px 40px rgba(0,0,0,0.4);left: 50%;top:50%;width:clamp(240px,86vw,450px);transform: translate(-50%,-50%);" class="warn-popup h-[max-content] absolute m-auto rounded-10 overflow-hidden flex-col pb-20">
        <div style="display: flex;align-items: center;justify-content: center;margin: 30px 0 5px;">
          <img src="@/assets/images/warning.png" style="width: 60px;height:60px;"/>
        </div>
        <div style="display: flex;justify-content: center;">
          <span style="color:#ffffff;font-weight: bold;font-size: 20px;text-align: center;">Aviso de Restrição de Jogo</span>
        </div>
        <div style="display: flex;text-align: center;margin: 16px;">
          <p style="font-size: 12px;">Prezado usuário, o sistema detectou um grande volume de lucros em sua conta. Para garantir a segurança dos seus fundos, solicitamos que realize o saque imediatamente. Assim que o saque for concluído e o seu próximo depósito for efetuado com sucesso, sua experiência de jogo retornará ao normal automaticamente. Caso tenha alguma dúvida, por favor, clique no link do atendimento ao cliente online. Desejamos-lhe uma excelente vida!</p>
        </div>
        <div style="display: flex; gap: 10px; margin: 18px 15px 0;">
          <!-- 左侧：Sacar Agora（黄色） -->
          <div @click="nav('/withdraw')" 
              style="flex: 1; font-weight: bold; display: flex; align-items: center; justify-content: center; 
                      background: #04807d; color: #fff; border-radius: 10px; padding: 14px 10px; 
                      font-size: 13px; cursor: pointer; transition: opacity 0.2s;"
              onmouseover="this.style.opacity='0.85'" 
              onmouseout="this.style.opacity='1'">
            Saque instantâneo
          </div>
          
          <!-- 右侧：Voltar ao Inicio（灰色） -->
          <div @click="showPopup = false" 
              style="flex: 1; font-weight: bold; display: flex; align-items: center; justify-content: center; 
                      background: #9CA3AF; color: #fff; border-radius: 10px; padding: 14px 10px; 
                      font-size: 13px; cursor: pointer; transition: opacity 0.2s;"
              onmouseover="this.style.opacity='0.85'" 
              onmouseout="this.style.opacity='1'">
            Voltar ao Inicio
          </div>
        </div>
      </div>
    </Vfm>
  </div>
</template>

<script setup>
import { computed, ref } from "vue";
import { useAppStore } from "@/stores/modules/app";
import { useUserStore } from "@/stores/modules/user";
import GameInfoVfm from "@/components/vfm/phone/GameInfo.vue";
import { useNav } from "@/hooks/useNav";

const appStore = useAppStore();
const userStore = useUserStore();
const nav = useNav();
const openMenu = ref(false);
const gameItem = ref(null);
const showPopup = ref(false)

// ===== 计算属性 =====
const userinfo = computed(() => {
  return userStore.userinfo;
});

const sortList = computed(() => {
  return appStore.mfrList.slice(0, 4);
});

// ===== Bonus 活动图片 =====
const bonusImages = [
  { src: new URL('@/assets/images/bonus/01.png', import.meta.url).href, name: 'Bonus 01', path: '/deposit' },
  { src: new URL('@/assets/images/bonus/02.png', import.meta.url).href, name: 'Bonus 02', path: '/invite' },
  { src: new URL('@/assets/images/bonus/03.png', import.meta.url).href, name: 'Bonus 03', path: '/vip' },
  { src: new URL('@/assets/images/bonus/04.png', import.meta.url).href, name: 'Bonus 04', path: '/rebate' },
  { src: new URL('@/assets/images/bonus/05.png', import.meta.url).href, name: 'Bonus 05', path: '/coupon' },
  { src: new URL('@/assets/images/bonus/06.png', import.meta.url).href, name: 'Bonus 06', path: '/mysteriousBox' },
  { src: new URL('@/assets/images/bonus/07.png', import.meta.url).href, name: 'Bonus 07', path: '/turntableCon' },

  { src: new URL('@/assets/images/bonus/10.png', import.meta.url).href, name: 'Bonus 10', path: '/platformTasks' },
  { src: new URL('@/assets/images/bonus/11.png', import.meta.url).href, name: 'Bonus 11', path: '/splitFlow' },
];

function handleBonusClick(img) {
  handleMenu();
  nav(img.path);
}

// ===== 分类点击 =====
function handleSortClick(item) {
  handleMenu();
  switch (item.id) {
    case 2:
      nav("/slot", {
        from: "column",
        id: item.id
      });
      break;
    case 3:
      nav("/slot", {
        from: "column",
        id: item.id
      });
      break;
    default:
      if (item.current) {
        nav("/slot", {
          from: "column",
          id: item.id,
          current: item.current
        });
      } else {
        nav("/slot", {
          from: "column",
          id: item.id
        });
      }
      break;
  }
}

function handleMenu() {
  openMenu.value = !openMenu.value;
  if (openMenu.value) {
    document.body.style.height = "100vh";
    document.body.style.overflow = "hidden";
  } else {
    document.body.style.height = "";
    document.body.style.overflow = "";
  }
}

function handleGameInfoClose() {
  gameItem.value = null;
  document.body.style.height = "";
  document.body.style.overflow = "";
}

function formatMoney(value) {
  if (value === undefined || value === null) return '0,00';
  const num = parseFloat(value);
  if (isNaN(num)) return '0,00';
  return num.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

function handleCustomer() {
  handleMenu();
  nav('/home');
}

defineExpose({
  handleMenu,
});
</script>

<style lang="scss" scoped>
.bg-color {
  background: #1a3a0a;
}

.translate-x-0 {
  transform: translateX(0);
}

.-translate-x-full {
  transform: translateX(-100%);
}
.none {
  display: none;
}
.v-background {
  background: rgba(0, 0, 0, 0.6) !important;
  transition: opacity 0.3s ease;
}

/* 侧边栏滑入动画 */
.fixed.z-503,
.fixed.z-502 {
  transition: transform 0.35s cubic-bezier(0.32, 0.72, 0, 1), opacity 0.3s ease;
}

/* 菜单内容依次进入动画 */
@keyframes slideInLeft {
  from {
    opacity: 0;
    transform: translateX(-30px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

.fixed.z-502 > div > div,
.fixed.z-502 > div[style*="border-bottom"] {
  opacity: 0;
  animation: none;
}

.fixed.z-502.pointer-events-auto > div > div,
.fixed.z-502.pointer-events-auto > div[style*="border-bottom"] {
  animation: slideInLeft 0.4s cubic-bezier(0.32, 0.72, 0, 1) forwards;
}

.fixed.z-502.pointer-events-auto > div:nth-child(1) { animation-delay: 0.05s; }
.fixed.z-502.pointer-events-auto > div:nth-child(2) { animation-delay: 0.1s; }
.fixed.z-502.pointer-events-auto > div:nth-child(3) { animation-delay: 0.15s; }
.fixed.z-502.pointer-events-auto > div:nth-child(4) { animation-delay: 0.2s; }

.sort {
  margin: 0 15px;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 10px;
}

.sort-item {
  margin: 0;
  background: #2b4f14;
  border: 1px solid #4C6B23;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 14px 10px;
  cursor: pointer;
  transition: background 0.2s;
}

.sort-item:active {
  background: #3d6b1f;
}

.sort-icon {
  width: 24px;
  height: 24px;
  margin-right: 12px;
  object-fit: contain;
}

.sort-label {
  color: #ffffff66;
  font-size: 13px;
  font-weight: 500;
}

/* ===== 功能菜单项 ===== */
.menu-func-list {
  margin: 15px 15px 0;
  display: flex;
  flex-direction: column;
  gap: 0;
}

.func-item {
  display: flex;
  align-items: center;
  background: #2b4f14;
  border: 1px solid #4C6B23;
  border-radius: 8px;
  padding: 12px 14px;
  margin-bottom: 10px;
  cursor: pointer;
  transition: background 0.2s;
}

.func-item:last-child {
  margin-bottom: 0;
}

.func-item:active {
  background: #3d6b1f;
}

.func-item-left {
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 12px;
  flex-shrink: 0;
}

.func-item-icon {
  width: 28px;
  height: 28px;
  object-fit: contain;
}

.func-item-right {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.func-item-title {
  color: #fff;
  font-size: 13px;
  font-weight: 600;
}

.func-item-value {
  color: #F7FB43;
  font-size: 14px;
  font-weight: 700;
}

.func-item-arrow {
  color: #888;
  flex-shrink: 0;
}

/* ===== Bonus 活动图片样式 ===== */
.bonus-section {
  margin: 15px 15px 0;
}

.bonus-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.bonus-item {
  border-radius: 8px;
  overflow: hidden;
  cursor: pointer;
  transition: opacity 0.2s;
}

.bonus-item:active {
  opacity: 0.85;
}

.bonus-img {
  width: 100%;
  display: block;
  object-fit: cover;
}
</style>